import { $, freeze, handleESC } from '../utils/Utils';

const welcome = (() => {
  const config = {
    parent: $('.js-welcomeParent')[0],
    dismiss: $('.js-welcomeDismiss')[0],
  };

  const handleClick = () => {
    // unfreeze HTML
    freeze.stop();
    // stop listening to ESC
    handleESC.stop();
  };

  const setup = () => {
    // freeze HTML so it's no possible to scroll
    freeze.start();
    // focus on dismiss button
    config.dismiss.focus();
    handleESC.init(() => {
      config.dismiss.click();
    });
    // handle click
    config.dismiss.addEventListener('click', handleClick);
  };

  const init = () => {
    if (config.dismiss) {
      setup();
    }
  };

  return {
    init,
  };
})();

export default welcome.init();
